/**
 * DashboardTabs Component
 *
 * Tab navigation for switching between different dashboards.
 */

import PropTypes from 'prop-types';
import './DashboardTabs.css';

const DashboardTabs = ({ dashboards, activeTabIndex, onTabChange }) => {
  if (!dashboards || dashboards.length === 0) {
    return null;
  }

  return (
    <div className="dashboard-tabs">
      <div className="tabs-container">
        {dashboards.map((dashboard, index) => {
          const isActive = index === activeTabIndex;
          const dashboardData = dashboard.dashboard || dashboard;

          return (
            <button
              key={dashboardData.id || index}
              className={`tab-button ${isActive ? 'active' : ''}`}
              onClick={() => onTabChange(index)}
              aria-selected={isActive}
              role="tab"
            >
              <span className="tab-label">{dashboardData.tab}</span>
              {dashboardData.title && (
                <span className="tab-subtitle">{dashboardData.title}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

DashboardTabs.propTypes = {
  dashboards: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        dashboard: PropTypes.shape({
          id: PropTypes.string.isRequired,
          tab: PropTypes.string.isRequired,
          title: PropTypes.string,
          template_id: PropTypes.string.isRequired,
          elements: PropTypes.object.isRequired,
        }),
      }),
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        tab: PropTypes.string.isRequired,
        title: PropTypes.string,
        template_id: PropTypes.string.isRequired,
        elements: PropTypes.object.isRequired,
      }),
    ])
  ).isRequired,
  activeTabIndex: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default DashboardTabs;
